import React, {useCallback} from 'react';
import {useStores} from "../../stores";
import {observer} from "mobx-react-lite";
import {
    ApiDropdownFilterComponent,
    DEFAULT
} from "../../components/visualization/api-dropdown-filter/ApiDropdownFilterComponent";
import type {Option, SelectionResult} from "../../components/visualization/api-dropdown-filter/ApiDropdownTypes";
import type {PageResponse} from "../../services/ApiTypes";

type Selection = SelectionResult<string>;
type Props = {
    wrapperClassName?: string,
    limitTags?: number,
}
export const SearchParentSupplierAutocomplete: React.FC<Props> = observer(({wrapperClassName, limitTags}) => {
    const {p, bagStore, materializedApi} = useStores();

    const selection: Selection = bagStore.advanced.filters.sp_ids || DEFAULT;

    /**
     * Note: We filter the parent suppliers by the selected suppliers as well
     *  We could consider not filtering the supplier and parent supplier fields together
     */
    const filter = bagStore.advanced.filterQueryParamsParentSupplier;

    const getOptions = useCallback(
        search => (bagStore.advanced.databagId && bagStore.advanced.ready) ? materializedApi.searchInsightParentSupplier(bagStore.advanced.databagId, filter, search)
            .then<PageResponse<Option>>(resp => ({
                count: resp.data.length,
                next: '',
                previous: '',
                results: resp.data.map(obj => ({
                    id: obj.sp_id,
                    label: obj.sp_name,
                    subLabel: obj.sp_id,
                    subTotalSpend: Number(obj.total_spend),
                    obj,
                }))
            })) : null,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [bagStore.advanced.databagId, bagStore.advanced.ready, filter]
    );

    if (!bagStore.advanced.ready) return <></>;
    return <ApiDropdownFilterComponent
        selection={selection}
        label={p.p.parentSupplierAltName ?? 'Parent Supplier'}
        enableLabelStatus
        getOptions={getOptions}
        showOptionSubLabel={false} // Do not show parent supplier ID in the dropdown
        onSelectionChange={selection => bagStore.advanced.parentSupplierFilterChanged(selection as Selection)}
        buttonProps={{fullWidth: true, sx: {height: '100%'}}}
    />
})
